import type { Proposal } from '@/models/proposal';
import type { Candidate } from '@/models/candidate';
import type { CandidateTopicProposalDoc } from '@/types/backend-contracts';
import { formatDateBr } from '@/utils/date';

export function toProposalViewModel(
  proposal: CandidateTopicProposalDoc & { id: string },
  topicId: string,
): Proposal {
  const reviewedAt = proposal.updatedAt?.toDate().toISOString() ?? proposal.createdAt?.toDate().toISOString() ?? new Date().toISOString();

  return {
    id: proposal.id,
    candidateId: proposal.candidateId,
    topicId,
    briefing: proposal.briefing,
    summary: proposal.summary,
    references: proposal.references.map((reference) => ({
      proposalId: reference.proposalId,
      title: reference.title,
      documentTitle: reference.documentTitle,
      url: reference.url,
      pageStart: reference.pageStart,
      pageEnd: reference.pageEnd,
    })),
    sourceTitle: proposal.sourceTitle || 'Fonte oficial',
    sourcePage: proposal.sourcePage,
    sourceUrl: proposal.sourceUrl || undefined,
    reviewedAt: formatDateBr(reviewedAt),
    status: 'found',
  };
}

export function toMissingProposalViewModel(candidateId: string, topicId: string): Proposal {
  return {
    id: `missing-${candidateId}-${topicId}`,
    candidateId,
    topicId,
    briefing: 'Não foram localizadas propostas cadastradas para esse candidato e tema.',
    summary: 'Não foram localizadas propostas cadastradas para esse candidato e tema.',
    references: [],
    sourceTitle: 'Fonte oficial',
    reviewedAt: formatDateBr(new Date().toISOString()),
    status: 'not_found',
  };
}

export type TopicProposalItem = {
  candidate: Candidate;
  proposal: Proposal;
};
